export default __webpack_public_path__ + "static/media/SD-gallery-07.e7a6d323.png";